// BFF: ○ none — renders the device list the member-profile shell already loaded.
export { default } from './PatientDetailMeta'
